import { styled } from 'stitches.config'

export const StepDot = styled('div', {
  size: '$$dotSize',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '$round',
  borderWidth: '3px',
  borderStyle: 'solid',
  border: '1px solid $secondary-600',
  color: '$secondary-800',
  backgroundColor: '$accent-white',
})

export const StepTitle = styled('div', {
  whiteSpace: 'nowrap',
})

export const CursorWrapper = styled('div', {
  cursor: 'pointer',

  variants: {
    disabled: {
      true: {
        cursor: 'not-allowed',

        '& a': {
          pointerEvents: 'none',
        },
      },
    },
  },
})

export const StepContainer = styled('li', {
  '& a': {
    display: 'flex',
    alignItems: 'center',
    gap: '$2',
  },

  [`& ${StepTitle}`]: {
    display: 'none',
    '@bp2': {
      display: 'block',
    },
  },

  ['&[data-status="complete"]']: {
    [`& ${StepDot}`]: {
      border: 'none',
      color: '$accent-white',
      backgroundColor: '$primary-500',
    },
  },

  ['&[aria-current="step"]']: {
    [`& ${StepDot}`]: {
      border: '2px solid $primary-500',
      color: '$primary-500',
    },
    [`& ${StepTitle}`]: {
      display: 'block',
      marginRight: '$2',
    },
  },
})

export const MealPlanStepperRoot = styled('ol', {
  display: 'flex',
  justifyContent: 'center',
  gap: '$2',
  listStyle: 'none',
  $$dotSize: '$sizes$4',
  fontWeight: '$medium',

  '@bp2': {
    $$dotSize: '$sizes$5',
  },
})
